"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSearchReviewData = exports.getReviewData = exports.getFeaturedReviewsData = void 0;
var storefront_api_key_1 = require("../constants/storefront-api-key");
var getFeaturedReviewsData = function (reviewIds) { return __awaiter(void 0, void 0, void 0, function () {
    var reviewsDataPromises, reviewsData, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                reviewsDataPromises = reviewIds.map(function (reviewId) { return __awaiter(void 0, void 0, void 0, function () {
                    var url, options, res, data;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = "https://api.yotpo.com/reviews/".concat(reviewId, "?utoken=utoken");
                                options = {
                                    method: 'GET',
                                    headers: {
                                        accept: 'application/json',
                                        'Content-Type': 'application/json',
                                    },
                                };
                                return [4 /*yield*/, fetch(url, options)];
                            case 1:
                                res = _a.sent();
                                return [4 /*yield*/, res.json()];
                            case 2:
                                data = _a.sent();
                                if (data.response) {
                                    data.response.review.content = decodeHtml(data.response.review.content);
                                    data.response.review.title = decodeHtml(data.response.review.title);
                                    return [2 /*return*/, data.response];
                                }
                                else {
                                    console.error('error while getting Yotpo featured reviews: ', data);
                                    return [2 /*return*/, null];
                                }
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [4 /*yield*/, Promise.all(reviewsDataPromises)];
            case 1:
                reviewsData = _a.sent();
                return [2 /*return*/, reviewsData];
            case 2:
                e_1 = _a.sent();
                console.error('error while getting Yotpo featured reviews: ', e_1);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.getFeaturedReviewsData = getFeaturedReviewsData;
// Use Yotpo's storefront API to retrieve review data
// ref: https://apidocs.yotpo.com/reference/retrieve-reviews-for-a-product
var getReviewData = function (productId, query) { return __awaiter(void 0, void 0, void 0, function () {
    var url, options, convertedQuery, queryString, res, data, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "https://api-cdn.yotpo.com/v1/widget/".concat(storefront_api_key_1.yotpo_STORE_ID, "/products/").concat(productId, "/reviews.json");
                options = {
                    method: 'GET',
                    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
                };
                if (query) {
                    convertedQuery = Object.entries(query).reduce(function (prev, _a) {
                        var _b;
                        var key = _a[0], value = _a[1];
                        return (__assign(__assign({}, prev), (_b = {}, _b[key] = value + '', _b)));
                    }, {});
                    queryString = new URLSearchParams(convertedQuery).toString();
                    url += '?' + queryString;
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch(url, options)];
            case 2:
                res = _a.sent();
                return [4 /*yield*/, res.json()];
            case 3:
                data = _a.sent();
                // If the data has response, it means that the request was successful
                if (data.response) {
                    // Decode HTML character to string format
                    // ref: https://stackoverflow.com/questions/63482621/json-how-to-remove-x27-letters-of-the-string/63537220
                    data.response.reviews.forEach(function (review) {
                        review.content = decodeHtml(review.content);
                        review.title = decodeHtml(review.title);
                    });
                    return [2 /*return*/, data.response];
                }
                else {
                    console.error('error while getting Yotpo reviews: ', data);
                    return [2 /*return*/, null];
                }
                return [3 /*break*/, 5];
            case 4:
                e_2 = _a.sent();
                console.error('error while getting Yotpo reviews: ', e_2);
                return [2 /*return*/, null];
            case 5: return [2 /*return*/];
        }
    });
}); };
exports.getReviewData = getReviewData;
var getSearchReviewData = function (productId, query, search) { return __awaiter(void 0, void 0, void 0, function () {
    var url, params, options, convertedQuery, queryString, res, data, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "https://api-cdn.yotpo.com/v1/reviews/".concat(storefront_api_key_1.yotpo_STORE_ID, "/filter.json");
                // remove free search text if the value is a empty string
                if ((search === null || search === void 0 ? void 0 : search.free_text_search) === '') {
                    search.free_text_search = undefined;
                }
                params = __assign({ domain_key: productId }, search);
                options = {
                    method: 'POST',
                    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
                    body: JSON.stringify(params),
                };
                if (query) {
                    convertedQuery = Object.entries(query).reduce(function (prev, _a) {
                        var _b;
                        var key = _a[0], value = _a[1];
                        return (__assign(__assign({}, prev), (_b = {}, _b[key] = value + '', _b)));
                    }, {});
                    queryString = new URLSearchParams(convertedQuery).toString();
                    url += '?' + queryString;
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch(url, options)];
            case 2:
                res = _a.sent();
                return [4 /*yield*/, res.json()];
            case 3:
                data = _a.sent();
                // If the data has response, it means that the request was successful
                if (data.response) {
                    // Decode HTML character to string format
                    // ref: https://stackoverflow.com/questions/63482621/json-how-to-remove-x27-letters-of-the-string/63537220
                    data.response.reviews.forEach(function (review) {
                        review.content = decodeHtml(review.content);
                        review.title = decodeHtml(review.title);
                    });
                    return [2 /*return*/, data.response];
                }
                else {
                    console.error('error while getting Yotpo reviews: ', data);
                    return [2 /*return*/, null];
                }
                return [3 /*break*/, 5];
            case 4:
                e_3 = _a.sent();
                console.error('error while getting Yotpo reviews: ', e_3);
                return [2 /*return*/, null];
            case 5: return [2 /*return*/];
        }
    });
}); };
exports.getSearchReviewData = getSearchReviewData;
var decodeHtml = function (text) {
    var doc = new DOMParser().parseFromString(text, 'text/html');
    return doc.documentElement.textContent || '';
};
